<template>
  <div class="cooperation">
    <!-- Banner 图片 -->
    <div v-if="data.bannerImage" class="banner-section">
      <img :src="data.bannerImage" alt="Banner" class="banner-image">
    </div>
    <!-- 底部图片 -->
    <div v-if="data.bottomImages && data.bottomImages.length > 0" class="bottom-section">
      <div class="bottom-container">
        <img v-for="(img, index) in data.bottomImages" :key="index" :src="img" :alt="`底部图片${index + 1}`" class="bottom-image">
      </div>
    </div>
    <!-- 留言表单区域 -->
    <div v-if="data.messageImage" class="message-section">
      <div class="message-container">
        <div class="message-image-wrapper">
          <img :src="data.messageImage" alt="留言" class="message-image">
        </div>
        <div class="message-form-wrapper">
          <h2 class="form-title">欢迎给我们留言</h2>
          <el-form :model="form" label-width="0" class="cooperation-form">
            <el-form-item>
              <el-input v-model="form.name" placeholder="姓名" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="form.phone" placeholder="电话" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="form.message" type="textarea" :rows="4" placeholder="留言" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                class="submit-btn"
                :loading="submitting"
                @click="handleSubmit"
              >
                {{ submitting ? '提交中...' : '立即提交' }}
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { editConsultationMessage } from '@/api/menu'

export default {
  name: 'CooperationComponent',
  props: {
    data: {
      type: Object,
      default: () => ({
        bannerImage: '',
        messageImage: '',
        bottomImages: []
      })
    }
  },
  data () {
    return {
      form: {
        name: '',
        phone: '',
        message: ''
      },
      submitting: false
    }
  },
  methods: {
    async handleSubmit () {
      // 表单验证
      if (!this.form.name || !this.form.name.trim()) {
        this.$message.warning('请填写姓名')
        return
      }
      if (!this.form.phone || !this.form.phone.trim()) {
        this.$message.warning('请填写电话')
        return
      }
      // 手机号格式验证
      const phoneReg = /^1[3-9]\d{9}$/
      if (!phoneReg.test(this.form.phone.trim())) {
        this.$message.warning('请输入正确的手机号码')
        return
      }
      if (!this.form.message || !this.form.message.trim()) {
        this.$message.warning('请填写留言内容')
        return
      }

      // 防止重复提交
      if (this.submitting) {
        return
      }

      this.submitting = true
      try {
        const res = await editConsultationMessage({
          name: this.form.name.trim(),
          mobile: this.form.phone.trim(),
          msgContent: this.form.message.trim(),
          status: 1 // 待处理
        })

        if (res && res.code === 1) {
          this.$message.success('提交成功！我们会尽快与您联系')
          // 清空表单
          this.form = {
            name: '',
            phone: '',
            message: ''
          }
        } else {
          this.$message.error(res.message || '提交失败，请稍后重试')
        }
      } catch (error) {
        console.error('提交咨询信息失败:', error)
        this.$message.error('提交失败，请稍后重试')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.cooperation {
  width: 100%;
}

/* Banner 区域 */
.banner-section {
  width: 100%;
  height: 400px;
  margin-bottom: 0;
}

.banner-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

/* 留言表单区域 */
.message-section {
  width: 100%;
  padding: 60px 0;
  background: #fff;
}

.message-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  gap: 40px;
  align-items: flex-start;
}

.message-image-wrapper {
  flex: 0 0 500px;
}

.message-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.message-form-wrapper {
  flex: 1;
}

.form-title {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin-bottom: 32px;
}

.cooperation-form {
  max-width: 500px;
}

.submit-btn {
  width: 100%;
  background: #52c41a;
  border-color: #52c41a;
  font-size: 16px;
  padding: 12px 0;
}

.submit-btn:hover {
  background: #73d13d;
  border-color: #73d13d;
}

/* 底部图片区域 */
.bottom-section {
  width: 100%;
  padding: 40px 0;
  background: #fff;
}

.bottom-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.bottom-image {
  max-width: 100%;
  height: auto;
  display: block;
}

/* 移动端 */
@media (max-width: 768px) {
  .banner-section {
    height: 250px;
  }

  .message-section {
    padding: 40px 0;
  }

  .message-container {
    flex-direction: column;
    gap: 24px;
    padding: 0 16px;
  }

  .message-image-wrapper {
    flex: 1;
    width: 100%;
  }

  .form-title {
    font-size: 24px;
    margin-bottom: 24px;
  }

  .cooperation-form {
    max-width: 100%;
  }

  .bottom-section {
    padding: 24px 0;
  }

  .bottom-container {
    padding: 0 16px;
    flex-direction: column;
  }

  .bottom-image {
    width: 100%;
  }
}
</style>
